const ukPhoneNumberRegex = /^(?:(?:(?:00\s?|\+)44\s?|0)(?:[123678]\d{8,9}))$/;

/**
 * Validates a UK phone number, ignoring whitespace. Returns true for empty
 * values so a `.required()` check owns the "missing" case rather than this
 * surfacing a format error for an empty field.
 */
export const isValidUKPhoneNumber = (value: string | undefined) => {
  if (!value) return true;

  const whitespaceRemoved = value.replace(/\s/g, '');
  return ukPhoneNumberRegex.test(whitespaceRemoved);
};
